import * as React from 'react';
import classNames from 'classnames';
import { IFileNameProps } from '../../FileUploader.types';
import { fileNameId, testIds } from '../../constants';
import { FileErrorIcon } from '../FileErrorIcon/FileErrorIcon';
import { CenterEllipsis } from '../CenterEllipsis/CenterEllipsis';
import style from './style/FileName.scss';
import { ReactComponent as XIcon } from './assets/xIcon.svg';
import { ReactComponent as SuccessIcon } from './assets/successIcon.svg';
import { ReactComponent as Loader } from './assets/loader.svg';

export const FileName: React.FunctionComponent<IFileNameProps> = ({
  id,
  fileName,
  withErrorIndication,
  withErrorTooltip = false,
  validationMessage = '',
  onFileRemoval,
  onXIconKeyDown,
  isPlaceholder,
  disabled,
  withCenterEllipsis = false,
  uploadStatus,
  withPopperBehaviour = false,
  isFixedPositionPopper = false,
}) => {
  const fileWithIconClassName = classNames(style.fileWithIcon, {
    [style.errorIndication]: withErrorIndication,
    [style.placeholder]: isPlaceholder,
    [style.disabled]: disabled,
    [style.withoutNativeTooltip]: !withCenterEllipsis,
    [style.withPopperBehaviour]: withPopperBehaviour,
    [style.uploadNotStarted]:
      withPopperBehaviour && uploadStatus === 'Not_Started',
    [style.fixedPositionPopper]: isFixedPositionPopper,
  });

  const isUploadingState = uploadStatus === 'Started' && withPopperBehaviour;
  const isDoneUploadingState = uploadStatus === 'Done' && withPopperBehaviour;

  const showErrorTooltip =
    withErrorTooltip && withErrorIndication && !isPlaceholder;
  return (
    <div className={fileWithIconClassName} data-testid={testIds.fileWithIcon}>
      <XIcon
        role="button"
        aria-label="Delete File"
        className={classNames(style.xIcon, {
          [style.isUploading]: isUploadingState,
          [style.uploadedSuccessfully]: isDoneUploadingState,
        })}
        data-testid={testIds.xIcon}
        tabIndex={0}
        onKeyDown={onXIconKeyDown}
        onClick={onFileRemoval}
      />
      <div
        className={classNames(style.fileName, {
          [style.isUploading]: isUploadingState,
          [style.withPopperBehaviour]: withPopperBehaviour,
        })}
        data-testid={testIds.fileName}
        title={fileName}
        aria-hidden="true"
        id={`${id}_${fileNameId}`}
      >
        {withCenterEllipsis ? <CenterEllipsis content={fileName} /> : fileName}
      </div>
      {withPopperBehaviour && (
        <div className={style.uploadStatusIndicator}>
          <Loader
            className={classNames(style.spinner, {
              [style.isUploading]: isUploadingState,
            })}
          />

          <SuccessIcon
            className={classNames(style.successIcon, {
              [style.uploadedSuccessfully]: isDoneUploadingState,
            })}
          />
        </div>
      )}
      {showErrorTooltip ? (
        <FileErrorIcon id={`${id}_${fileNameId}`} message={validationMessage} />
      ) : null}
    </div>
  );
};
